import { render } from "./MassUpdateModal.vue?vue&type=template&id=5552e5ef"
import script from "./MassUpdateModal.vue?vue&type=script&lang=js"
export * from "./MassUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__